import React, { Suspense, useContext, useState } from "react";

import LayoutDashboard from "layouts/layout-dashboard-collapse"; // Assuming this is a layout component

import FullLoader from "components/loader/full-loader";
import { Dropdown } from "react-bootstrap";
import { useDeleteData, useFetchData } from "hooks/useApiHooks";
import { AppContext } from "contexts/AppContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";
import { useDeleteHandler } from "hooks/useDeleteHandler";
import { buildQueryString } from "utils/queryHelpers";
import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { useProduct } from "contexts/v1/masterData/ProductContext";
import { ProductCreateProvider } from "contexts/v1/masterData/ProductCreateContext";
import Swal from "sweetalert2";
import { deleteRequest } from "services/api";

// Main Product Page Component
const ProductPage = () => {
  const { products, refetch } = useProduct();
  console.log("products", products);

  const [search, setSearch] = useState(""); // For search input
  const [currentPage, setCurrentPage] = useState(1); // For pagination
  const { handleSuccess, handleError, showCanvasHandler, handleSuccessToast } = useCanvasHandler();

  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Product",
      <ProductCreateProvider>
        <CreatePage
          // onSuccess={handleSuccess}
          onSuccess={() => {
            // handleSuccess(true, "Product created successfully");
            handleSuccessToast(true, "Product createing");
            refetch();
          }}
          onError={handleError}
        />
      </ProductCreateProvider>
    );
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Product",
      <CreatePage
        initialData={data}
        // onSuccess={handleSuccess}
        onSuccess={() => {
          // handleSuccess(true, "Product updated successfully");
          handleSuccessToast(true, "Product updateding");
          refetch();
        }}
        onError={handleError}
      />
    );
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`/product/${id}`);

        if (response.success) {
          handleSuccessToast(true, "Product deleteing");
          refetch();
        }
      }
    });
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  const totalPages = products.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages,
    currentPage,
    onPageChange: setCurrentPage,
    visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  });

  if (products.loading) return <FullLoader />;
  if (products.error) return <Suspense error={products.error} />;

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-5">
        <div className="table-container vh-100">
          <div className="search-container mb-3">
            {/* Search input */}
            {/* <SearchInput handleSearch={handleSearch} defaultValue={search} /> */}
            <SearchInput />

            {/* Create button */}
            <button className="btn btn-primary" onClick={handleCreate}>
              Create Product
            </button>
          </div>

          {/* Table */}
          <div className="table table-responsive">
            <table className="table table-hover table-vcenter">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Product Name</th>
                  <th>Price</th>
                  <th>Published Price</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              {products.data.length > 0 && (
                <tbody>
                  {products.data.map((data, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.name}</td>
                        <td>Rp {parseInt(data.price).toLocaleString()}</td>
                        <td>Rp {parseInt(data.price_sale).toLocaleString()}</td>

                        <td className="text-end">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="default"
                              id="dropdownMenuButton1"
                            >
                              Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => handleUpdate(e, data)}
                              >
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete(data.id);
                                }}
                              >
                                Remove
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              )}
              {/* tampilkan belum ada data ketika 0 */}
              {products.data.length === 0 && (
                <tbody>
                  <tr>
                    <td colSpan="5" className="text-center">
                      No data available
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>

          {/* Pagination */}
          <div className="mt-4">{Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default ProductPage;

// Search Input Component
const SearchInput = () => {
  const { handleSearch, filterOptions } = useProduct();
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
